import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-xxl" }
const _hoisted_2 = { class: "d-flex flex-column h-100 justify-content-lg-center" }
const _hoisted_3 = { class: "w-lg-500px bg-white w-100 rounded p-10 m-10 p-lg-15 mx-auto" }
const _hoisted_4 = { class: "text-center mb-10" }
const _hoisted_5 = { class: "text-main mb-3" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-end mb-18" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg px-18 fs-1 btn-primary mb-5"
}
const _hoisted_9 = { class: "indicator-label" }
const _hoisted_10 = { class: "indicator-progress" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_12 = { class: "text-gray-400 text-center fw-bold fs-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          class: "form w-100",
          onSubmit: _withModifiers(_ctx.onSubmitLogin, ["prevent"]),
          model: _ctx.loginForm,
          ref: "loginFormRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("signInToFatora")), 1)
            ]),
            _createVNode(_component_el_form_item, {
              class: "mb-10",
              prop: "email",
              rules: [
              {
                required: true,
                message: _ctx.$t('emailRequired'),
                trigger: 'change',
              },
            ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "fs-3",
                  modelValue: _ctx.loginForm.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.email) = $event)),
                  type: "email",
                  placeholder: _ctx.$t('email'),
                  autocomplete: "off"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_el_form_item, {
              prop: "password",
              class: "mb-2",
              rules: [
              {
                required: true,
                message: _ctx.$t('passwordRequired'),
                trigger: 'change',
              },
            ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "fs-3",
                  modelValue: _ctx.loginForm.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                  type: "password",
                  placeholder: _ctx.$t('password'),
                  autocomplete: "off"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: {
                name: 'password-reset',
              },
                class: "link-success fs-3 mt-2 d-block text-decoration-underline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("forgetPassword")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("signIn")), 1),
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + " ", 1),
                  _hoisted_11
                ])
              ], 512)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.$t("newHere")) + " ", 1),
              _createVNode(_component_router_link, {
                to: { name: 'sign-up' },
                class: "fw-bolder text-decoration-underline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("signUp")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "model"])
      ])
    ])
  ]))
}